import React, { FC } from 'react';

import { Box, Flex, Text } from '@adsk/alloy-react-box';
import { LinkButton } from '@adsk/alloy-react-button';
import { AlertWarningFilledIcon } from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';

import { useTranslation } from '../../i18n';

type AttachmentsListErrorStateProps = {
  onRetry?: () => void;
};

const AttachmentsListErrorState: FC<AttachmentsListErrorStateProps> = ({
  onRetry,
}) => {
  const { t } = useTranslation();

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      padding={16}
      data-testid="AttachmentsListErrorState"
    >
      <AlertWarningFilledIcon color={theme.colors.red500} />
      <Box>
        <Text typography="bodyMedium" style={{ color: theme.colors.red500 }}>
          {t('GENERAL_ERROR_DOT')}
        </Text>{' '}
        <LinkButton onClick={onRetry}>{t('RETRY')}</LinkButton>
      </Box>
    </Flex>
  );
};

export default AttachmentsListErrorState;
